export default "__VITE_ASSET__00f2b0ca__"